import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  @Input() headerImageUrl: string = '';
  @Input() bodyIconUrl: string = '';
  @Input() isNoStudyDay: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() goToCalendar = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.close.emit();
  }

  onGoToCalendar(): void {
    this.goToCalendar.emit();
  }
}
